import { colors } from '@argo/principles';

export const HOME_PAGE = 'homepage';

export const HERO_IMAGE_MAX_WIDTH = 1920;

export const SUPER_HERO_MAX_WIDTH = 1300;
export const SUPER_HERO_MOBILE_WIDTH = 600;

export const SUPER_HERO_LOGO_MAX_WIDTH = 270;

export const SUPER_HERO_MAX_HEIGHT = 432;

export const SUPER_HERO_HEIGHT = {
  BASE: 432,
  MD: 540,
  LG: 583,
};

export const HERO_IMAGE_HEIGHT = {
  BASE: 415,
  SM: 258,
  MD: 320,
  LG: 402,
  XL: 432,
};

export const CIM_WIDTH = {
  SM: 335,
  MD: 520,
  LG: 335,
  XL: 500,
};

export const SPACE_TO_NAV = 40; // accounts for overhang of logo's ribbon

export const HERO_ZINDEX = {
  HeroWrapper: '0',
  CIM: '1',
};

export const HERO_SECTION_BGCOLOR = colors.neutral.doveGray;
